import script from "./SalaryChange.vue?vue&type=script&setup=true&lang=js"
export * from "./SalaryChange.vue?vue&type=script&setup=true&lang=js"

import "./SalaryChange.vue?vue&type=style&index=0&id=61039e68&lang=less&scoped=true"

import exportComponent from "D:\\cwzl\\cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61039e68"]])

export default __exports__